/* eslint-disable prefer-template */
import React from 'react';
import { Field } from 'formik';
import { useQuery } from '@apollo/client';
import ReactSelect from 'components/Fields/ReactSelect';
import Loader from 'components/common/Loader';
import { SUBSCRIPTION_PLANS_QUERY } from 'pages/SubscriptionPlans/subscriptionPlanGraphQL';
import { defaultDeleteFilter } from 'utils/constants';

const VendorSubscriptionPlan = ({ currency = 'INR', op = 'NEQ', ...props }) => {
  const { data, loading, error } = useQuery(SUBSCRIPTION_PLANS_QUERY, {
    variables: {
      filter: [
        { ...defaultDeleteFilter },
        {
          key: 'isAddOn',
          value: true,
          type: 'BOOLEAN',
          op,
        },
        {
          key: 'currency',
          value: currency,
          type: 'STRING',
          op: 'EQ',
        },

        {
          key: 'status',
          value: 'ACTIVE',
          type: 'STRING',
          op: 'EQ',
        },
      ],
      pagination: false,
      sortCol: 'planName',
      sortDirection: 'ASC',
    },
    fetchPolicy: 'network-only',
  });

  const getOptions = (option) => {
    // if (op !== 'EQ') {
    return option.planName + ' - ' + option.duration + ' days';
    // }
    // return option.planName;
  };

  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message} `;

  return (
    <div>
      {' '}
      <Field
        data={data?.subscriptionPlans?.subscriptionPlans || []}
        component={ReactSelect}
        keys={{ id: 'id', label: 'label' }}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => getOptions(option)}
        {...props}
      />
    </div>
  );
};

export default VendorSubscriptionPlan;
